import React from 'react';

type EnergyIconProps = React.SVGProps<SVGSVGElement>;

const EnergySavingsIcon: React.FC<EnergyIconProps> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={61}
      height={64}
      viewBox="0 0 61 64"
      fill="none"
      {...props}
    >
      <path
        d="M38.3973 30.9062H32.4285L35.4074 20.4219L22.5609 33.0939H28.5296L25.5398 43.5782L38.3973 30.9062Z"
        stroke="#176EBF"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9122 50.6532C16.3842 54.3284 20.8022 56.8296 25.6097 57.8417C30.4171 58.8537 35.399 58.3315 39.9276 56.3406C44.4562 54.3498 48.329 50.9794 51.058 46.6541C53.787 42.3289 55.2501 37.2422 55.2631 32.035V31.1855"
        stroke="#176EBF"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.479 52.003C28.0081 52.0122 25.5597 51.503 23.2744 50.5046C20.989 49.5062 18.9117 48.0382 17.1616 46.1848"
        stroke="#176EBF"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx={34.3779}
        cy={51.6305}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={38.3973}
        cy={50.1643}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={42.0661}
        cy={47.7325}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={45.1655}
        cy={44.5557}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={47.4654}
        cy={40.7854}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={48.8344}
        cy={36.5149}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={49.2944}
        cy={32}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <path
        d="M48.0349 13.3469C44.5629 9.67177 40.1449 7.17057 35.3375 6.15848C30.53 5.14638 25.5481 5.66866 21.0195 7.65951C16.4909 9.65036 12.6182 13.0207 9.88918 17.346C7.16017 21.6712 5.69701 26.7579 5.68402 31.9651V32.8146"
        stroke="#176EBF"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.4791 11.9971C32.9485 11.9875 35.3953 12.4965 37.6789 13.495C39.9625 14.4935 42.0378 15.9617 43.7856 17.8153"
        stroke="#176EBF"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx={26.5693}
        cy={12.3695}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={22.5608}
        cy={13.8357}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={18.881}
        cy={16.2677}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={15.7817}
        cy={19.4444}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={13.4927}
        cy={23.2146}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={12.1128}
        cy={27.4851}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <ellipse
        cx={11.6528}
        cy={32}
        rx={0.547594}
        ry={0.581818}
        fill="#176EBF"
      />
      <path
        d="M8.76151 52.1426V50.0946C9.6021 49.9131 10.3611 49.4372 10.917 48.7431C11.473 48.049 11.7938 47.1769 11.828 46.2662C11.7686 45.1528 11.2982 44.1092 10.5191 43.362C9.73992 42.6148 8.71484 42.2242 7.66632 42.275C7.20839 42.3278 6.74918 42.1882 6.38692 41.8859C6.02465 41.5836 5.78809 41.1427 5.72784 40.6575C5.78809 40.1723 6.02465 39.7314 6.38692 39.4291C6.74918 39.1269 7.20839 38.9872 7.66632 39.0401C8.12548 38.987 8.58601 39.1263 8.95004 39.4284C9.31406 39.7304 9.55289 40.1713 9.61576 40.6575H11.8061C11.7711 39.7507 11.4528 38.882 10.9015 38.1888C10.3502 37.4955 9.5972 37.0171 8.76151 36.8291V35.0255H6.57114V36.8291C5.73342 37.0149 4.97799 37.4923 4.42451 38.1857C3.87103 38.8792 3.55116 39.7491 3.51556 40.6575C3.57504 41.7688 4.04386 42.8106 4.82062 43.5575C5.59738 44.3044 6.61965 44.6964 7.66632 44.6488C8.12496 44.5987 8.58403 44.7392 8.9474 45.0407C9.31078 45.3422 9.55028 45.7813 9.61576 46.2662C9.55285 46.7533 9.31444 47.1953 8.95078 47.4992C8.58712 47.8031 8.12661 47.9451 7.66632 47.8953C7.20727 47.9449 6.74808 47.8026 6.38618 47.4984C6.02428 47.1943 5.78814 46.7523 5.72784 46.2662H3.53747C3.57118 47.1753 3.89038 48.0462 4.44417 48.74C4.99797 49.4339 5.75446 49.9108 6.59304 50.0946V52.1426H8.76151Z"
        fill="#176EBF"
      />
      <path
        d="M53.7408 30.557V28.5207C54.5777 28.3331 55.3321 27.8551 55.8852 27.1621C56.4384 26.469 56.759 25.6002 56.7964 24.6923C56.7398 23.5747 56.2691 22.5264 55.4872 21.7763C54.7054 21.0263 53.6759 20.6355 52.6238 20.6894C52.1646 20.7424 51.7041 20.6031 51.34 20.3011C50.976 19.9991 50.7372 19.5581 50.6743 19.0719C50.783 18.6116 51.0333 18.203 51.3855 17.9111C51.7377 17.6192 52.1716 17.4606 52.6183 17.4606C53.065 17.4606 53.4989 17.6192 53.851 17.9111C54.2032 18.203 54.4535 18.6116 54.5622 19.0719H56.7526C56.717 18.1635 56.3971 17.2936 55.8437 16.6002C55.2902 15.9067 54.5348 15.4293 53.697 15.2436V13.4399H51.4738V15.2436C50.6341 15.427 49.8762 15.9034 49.3205 16.5971C48.7649 17.2908 48.4435 18.1619 48.4073 19.0719C48.4667 20.1896 48.9401 21.2368 49.724 21.9847C50.508 22.7326 51.5387 23.1204 52.5909 23.0632C53.05 23.0136 53.5091 23.156 53.871 23.4601C54.2329 23.7643 54.4691 24.2062 54.5294 24.6923C54.4207 25.1526 54.1704 25.5612 53.8182 25.8531C53.466 26.1451 53.0321 26.3036 52.5854 26.3036C52.1387 26.3036 51.7049 26.1451 51.3527 25.8531C51.0005 25.5612 50.7502 25.1526 50.6415 24.6923H48.4511C48.4849 25.5959 48.8001 26.4621 49.3471 27.155C49.8942 27.8478 50.6422 28.3281 51.4738 28.5207V30.557H53.7408Z"
        fill="#176EBF"
      />
    </svg>
  );
};

export default EnergySavingsIcon;
